import HelperMixin from '../../Shared/HelperMixin.vue';
import PaginationHelper from '../../Shared/PaginationHelper.vue';
import { printStockVoucher } from './printStockVoucher';
import mohLogo from '../../assets/moh-logo.png';

export default {
    name: 'StockVouchers',
    mixins: [HelperMixin],
    components: {
        PaginationHelper
    },
    watch: {
        '$route.query.id'(value) {
            const id = Number(value);
            if (id) {
                this.openDetail({ id });
                return;
            }

            this.detailDialog = false;
        }
    },

    async created() {
        await this.CheckLoginStatus();
        if (!this.loginDetails || !this.canViewStockVouchersUi()) {
            this.logout();
            return;
        }
        this.GetInfo();
        if (this.$route && this.$route.query && this.$route.query.id) {
            this.openDetail({ id: Number(this.$route.query.id) });
        }
    },

    computed: {
        isMinistryAdmin() {
            return this.loginDetails && !this.isFacilityCenterRole();
        },
        canCreateDepartmentIssue() {
            return this.isFacilityCenterRole() && this.canIssueToFacilityDepartmentsUi();
        },
        statsCards() {
            return [
                this.statCard('إجمالي السندات', this.pages, 'primary', 'ti ti-files'),
                this.statCard('إجمالي الكمية الحالية', this.sumWhere(this.Info, item => item.totalQty), 'info', 'ti ti-box-multiple'),
                this.statCard('سندات صرف', this.countWhere(this.Info, item => String(item.voucherTypeLabel || '').includes('صرف')), 'warning', 'ti ti-arrow-up-right'),
                this.statCard('سندات إدخال', this.countWhere(this.Info, item => String(item.voucherTypeLabel || '').includes('إدخال')), 'success', 'ti ti-arrow-down-left'),
            ];
        }
    },

    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            Search: '',
            voucherType: 0,
            Info: [],
            detail: null,
            detailDialog: false,
            createDialog: false,
            returnDialog: false,
            returnForm: {
                facilityDepartmentId: '',
                targetStockingId: '',
                reason: '',
                note: '',
                lines: [{ productsId: '', quantity: 1, unitMeasureId: '', note: '' }]
            },
            departments: [],
            sourceStockings: [],
            products: [],
            issueForm: {
                facilityDepartmentId: '',
                sourceStockingId: '',
                note: '',
                lines: []
            },
            // مراجعة بيانات الأصناف قبل إتمام الصرف الداخلي (إلزامية)
            issueConfirmDialog: false,
            issueConfirmLines: [],
            issueConfirming: false
        };
    },

    methods: {
        formatStatValue(value) {
            return new Intl.NumberFormat('en-US').format(Number(value || 0));
        },
        statSubtitle(title) {
            if (title === 'إجمالي السندات') return 'إجمالي السجلات المتاحة وفق عوامل التصفية الحالية';
            if (title === 'إجمالي الكمية الحالية') return 'مجموع الكميات الظاهرة في الصفحة الحالية';
            if (title === 'سندات صرف') return 'سندات الصرف والمتابعة الداخلية للمخازن';
            if (title === 'سندات إدخال') return 'سندات الإدخال والاستلام المعتمدة بالنظام';
            return 'ملخص سريع لحالة السندات';
        },
        voucherMetaText(item) {
            if (!item) return '-';
            const parts = [];
            if (item.referenceCode) parts.push(`المرجع: ${item.referenceCode}`);
            else if (item.sourceEntityType) parts.push(item.sourceEntityType);
            parts.push(`الكمية: ${Number(item.totalQty || 0)}`);
            return parts.join(' | ');
        },
        locationPrimaryText(item) {
            if (!item) return '-';
            if (this.isMinistryAdmin) return item.branchName || '-';
            return item.departmentName || item.branchName || '-';
        },
        locationSecondaryText(item) {
            if (!item) return 'بدون جهة فرعية';
            if (this.isMinistryAdmin) return item.departmentName || item.stockingName || 'بدون قسم محدد';
            return item.stockingName || item.referenceCode || 'بدون مخزن محدد';
        },
        voucherTone(item) {
            const label = String(item && item.voucherTypeLabel ? item.voucherTypeLabel : '').toLowerCase();
            if (label.includes('إدخال')) return 'success';
            if (label.includes('إرجاع')) return 'info';
            if (label.includes('إعدام')) return 'danger';
            if (label.includes('تدوير')) return 'warning';
            if (label.includes('زيادة')) return 'success';
            if (label.includes('عجز')) return 'danger';
            return 'primary';
        },
        voucherIcon(item) {
            const label = String(item && item.voucherTypeLabel ? item.voucherTypeLabel : '');
            if (label.includes('إدخال')) return 'ti ti-arrow-down-left';
            if (label.includes('إرجاع')) return 'ti ti-arrow-back-up';
            if (label.includes('إعدام')) return 'ti ti-trash';
            if (label.includes('تدوير')) return 'ti ti-refresh';
            if (label.includes('زيادة')) return 'ti ti-plus';
            if (label.includes('عجز')) return 'ti ti-minus';
            return 'ti ti-arrow-up-right';
        },
        typeHintText(item) {
            if (!item) return '-';
            if (item.referenceCode) return `مرجع السند: ${item.referenceCode}`;
            if (item.sourceEntityType) return `مصدر الحركة: ${item.sourceEntityType}`;
            return 'سند رسمي بدون مرجع إضافي';
        },
        statusBadgeClass(status, label) {
            const normalizedStatus = Number(status);
            const normalizedLabel = String(label || '').toLowerCase();
            if (normalizedStatus === 3 || normalizedLabel.includes('معتمد') || normalizedLabel.includes('مكتمل') || normalizedLabel.includes('منفذ')) return 'bg-label-success';
            if (normalizedStatus === 4 || normalizedLabel.includes('مرفوض') || normalizedLabel.includes('ملغي')) return 'bg-label-danger';
            if (normalizedStatus === 2 || normalizedLabel.includes('مرسل') || normalizedLabel.includes('قيد') || normalizedLabel.includes('بانتظار')) return 'bg-label-warning';
            return 'bg-label-primary';
        },
        statusHintText(item) {
            if (!item) return '-';
            if (item.printedOn) return `آخر طباعة ${this.moment(item.printedOn)}`;
            if (item.referenceCode) return `مرتبطة بالمرجع ${item.referenceCode}`;
            return 'جاهز لعرض التفاصيل والطباعة الرسمية';
        },
        loadIssueMetadata() {
            if (!this.canCreateDepartmentIssue) return Promise.resolve();
            return Promise.all([
                this.$http.GetAllFacilityDepartments(),
                this.$http.GetAllStocking()
            ]).then(([departmentsRes, stockingRes]) => {
                this.departments = departmentsRes.data.info || [];
                this.sourceStockings = (stockingRes.data.info || []).filter((x) => !x.facilityDepartmentId);
                this.products = [];
            });
        },
        onSourceStockingChanged() {
            this.loadIssueProductsByStocking();
        },
        loadIssueProductsByStocking() {
            const sourceStockingId = Number(this.issueForm.sourceStockingId || 0);
            if (!sourceStockingId) {
                this.products = [];
                this.syncIssueLinesWithAvailableProducts();
                return Promise.resolve();
            }
            return this.$http.GetDepartmentIssueProducts(sourceStockingId)
                .then((response) => {
                    this.products = response.data.info || [];
                    this.syncIssueLinesWithAvailableProducts();
                })
                .catch(() => {
                    this.products = [];
                    this.syncIssueLinesWithAvailableProducts();
                });
        },
        syncIssueLinesWithAvailableProducts() {
            const availableIds = new Set((this.products || []).map((x) => Number(x.id)));
            (this.issueForm.lines || []).forEach((line) => {
                if (Number(line.productsId || 0) > 0 && !availableIds.has(Number(line.productsId))) {
                    line.productsId = '';
                    line.unitMeasureId = '';
                    return;
                }
                // إعادة ضبط الوحدة بعد تحميل الأصناف، لأن معاملات التعبئة تأتي معها.
                if (Number(line.productsId || 0) > 0 && !line.unitMeasureId) {
                    this.onIssueLineProductChanged(line);
                }
            });
        },
        lineProduct(line) {
            const id = Number((line && line.productsId) || 0);
            if (!id) return null;
            return (this.products || []).find((x) => Number(x.id) === id) || null;
        },
        lineUnits(line) {
            const product = this.lineProduct(line);
            return (product && product.units) || [];
        },
        /**
         * forIssue: الصرف للقسم لا يأخذ المنتهي (ExpiryPolicy)، والإرجاع منه يأخذه —
         * إرجاع المنتهي للمخزن الرئيسي مسار مشروع. والمساعدات مشتركة بين النافذتين،
         * فالوضع يُمرَّر صراحةً والافتراضي سلوك الإرجاع كما كان.
         */
        lineAvailableText(line, forIssue) {
            const product = this.lineProduct(line);
            if (!product) return '';
            if (forIssue && product.expiredQuantity > 0) {
                const dispensable = product.dispensableText || String(product.dispensableQuantity || 0);
                return `${dispensable} (ويوجد ${product.expiredText} منتهية لا تُصرف)`;
            }
            return product.availableText || String(product.availableQuantity || 0);
        },
        lineDispensableQuantity(product) {
            if (!product) return 0;
            return product.dispensableQuantity !== undefined && product.dispensableQuantity !== null
                ? Number(product.dispensableQuantity)
                : Number(product.availableQuantity || 0);
        },
        defaultUnitForProduct(product) {
            const units = (product && product.units) || [];
            if (!units.length) return '';
            const base = units.find((u) => u.isBaseUnit);
            return base ? base.unitMeasureId : units[0].unitMeasureId;
        },
        onIssueLineProductChanged(line) {
            line.unitMeasureId = this.defaultUnitForProduct(this.lineProduct(line));
        },
        /// الكمية بعد التحويل للوحدة الأساسية — تعكس نفس حساب الخادم لتُعرض قبل الإرسال.
        lineBaseQuantity(line) {
            const quantity = Number((line && line.quantity) || 0);
            if (quantity <= 0) return 0;

            const units = this.lineUnits(line);
            if (!units.length) return quantity;

            const unit = units.find((u) => Number(u.unitMeasureId) === Number(line.unitMeasureId));
            if (!unit) return 0;

            return quantity * Number(unit.baseUnitsPerUnit || 1);
        },
        lineBaseQuantityText(line) {
            const base = this.lineBaseQuantity(line);
            if (base <= 0) return '';
            const product = this.lineProduct(line);
            const name = (product && product.baseUnitName) || '';
            return name ? base + ' ' + name : String(base);
        },
        lineExceedsAvailable(line, forIssue) {
            const product = this.lineProduct(line);
            if (!product) return false;
            const limit = forIssue
                ? this.lineDispensableQuantity(product)
                : Number(product.availableQuantity || 0);
            return this.lineBaseQuantity(line) > limit;
        },
        /// دفعات الصنف كما يرتبها الخادم: الأقرب انتهاءً أولاً.
        lineBatches(line) {
            const product = this.lineProduct(line);
            return (product && product.batches) || [];
        },
        /// توزيع الكمية المطلوبة على الدفعات بنفس منطق الخادم (FEFO) — عرض فقط قبل التنفيذ.
        lineBatchPlan(line, forIssue) {
            const batches = this.lineBatches(line);
            if (!batches.length) return [];

            let remaining = this.lineBaseQuantity(line);
            const product = this.lineProduct(line);
            const unitName = (product && product.baseUnitName) || '';

            return batches.map((b) => {
                // في الصرف يُتجاوز المنتهي كما يفعل الخادم؛ وفي الإرجاع يبقى قابلاً للخصم.
                const available = (forIssue && b.isExpired) ? 0 : Number(b.quantity || 0);
                const take = remaining > 0 ? Math.min(remaining, available) : 0;
                remaining -= take;
                return {
                    batchNumber: b.batchNumber,
                    expiryDate: b.expiryDate,
                    quantity: available,
                    quantityText: b.quantityText,
                    take,
                    takeText: take > 0 ? (unitName ? take + ' ' + unitName : String(take)) : '',
                };
            });
        },
        GetInfo(pageNo) {
            this.pageNo = pageNo || 1;
            this.$blockUI.Start();
            this.$http.GetStockVouchers(this.pageNo, this.pageSize, this.Search, this.voucherType)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.Info = response.data.info || [];
                    this.pages = response.data.count || 0;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.Info = [];
                    this.pages = 0;
                });
        },
        openDetail(item) {
            const id = item && item.id ? item.id : null;
            if (!id) return;
            this.$blockUI.Start();
            this.$http.GetStockVoucher(id)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.detail = response.data.info;
                    this.detailDialog = true;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });
        },
        openCreateDialog() {
            this.issueForm = {
                facilityDepartmentId: '',
                sourceStockingId: '',
                note: '',
                lines: [{ productsId: '', quantity: 1, unitMeasureId: '', note: '' }]
            };
            this.createDialog = true;
            this.loadIssueMetadata();
        },

        // ─── الإرجاع من القسم إلى مخزن المرفق (عكس الصرف الداخلي) ───────────
        openReturnDialog() {
            this.returnForm = {
                facilityDepartmentId: '',
                targetStockingId: '',
                reason: '',
                note: '',
                lines: [{ productsId: '', quantity: 1, unitMeasureId: '', note: '' }]
            };
            this.products = [];
            this.returnDialog = true;
            this.loadIssueMetadata();
        },
        /// أصناف القسم تُحمَّل من مخزنه هو، لا من مخزن المرفق.
        onReturnDepartmentChanged() {
            this.products = [];
            this.returnForm.lines.forEach((l) => { l.productsId = ''; l.unitMeasureId = ''; });
            const departmentId = Number(this.returnForm.facilityDepartmentId || 0);
            if (!departmentId) return;
            this.$blockUI.Start();
            this.$http.GetDepartmentProductsForReturn(departmentId)
                .then((res) => {
                    this.$blockUI.Stop();
                    this.products = (res && res.data && res.data.info) || [];
                    if (!this.products.length) {
                        this.$helper.ShowMessage('warning', 'تنبيه', 'لا يوجد رصيد لدى هذا القسم لإرجاعه.');
                    }
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.products = [];
                });
        },
        addReturnLine() {
            if (!this.returnForm.facilityDepartmentId) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'يرجى اختيار القسم أولاً.');
                return;
            }
            this.returnForm.lines.push({ productsId: '', quantity: 1, unitMeasureId: '', note: '' });
        },
        removeReturnLine(index) {
            if (this.returnForm.lines.length <= 1) return;
            this.returnForm.lines.splice(index, 1);
        },
        submitDepartmentReturn() {
            const body = {
                facilityDepartmentId: Number(this.returnForm.facilityDepartmentId || 0),
                targetStockingId: Number(this.returnForm.targetStockingId || 0),
                reason: (this.returnForm.reason || '').trim(),
                note: this.returnForm.note || '',
                lines: (this.returnForm.lines || [])
                    .filter((x) => Number(x.productsId) > 0 && Number(x.quantity) > 0)
                    .map((x) => ({
                        productsId: Number(x.productsId),
                        quantity: Number(x.quantity),
                        unitMeasureId: Number(x.unitMeasureId || 0) > 0 ? Number(x.unitMeasureId) : null,
                        note: x.note || ''
                    }))
            };
            if (!body.facilityDepartmentId || !body.targetStockingId || body.lines.length === 0) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'يرجى استكمال بيانات الإرجاع.');
                return;
            }
            if (!body.reason) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'سبب الإرجاع مطلوب — يُسجَّل على السند للمراجعة.');
                return;
            }

            const missingUnit = (this.returnForm.lines || []).find((x) =>
                Number(x.productsId) > 0 && this.lineUnits(x).length > 0 && !Number(x.unitMeasureId || 0));
            if (missingUnit) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'يرجى اختيار الوحدة لكل بند.');
                return;
            }

            const overAvailable = (this.returnForm.lines || []).find((x) =>
                Number(x.productsId) > 0 && this.lineExceedsAvailable(x));
            if (overAvailable) {
                const product = this.lineProduct(overAvailable);
                this.$helper.ShowMessage('warning', 'تنبيه',
                    'الكمية تتجاوز رصيد القسم للصنف ' + ((product && product.name) || '') + '.');
                return;
            }

            this.$blockUI.Start();
            this.$http.CreateDepartmentReturnVoucher(body)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.returnDialog = false;
                    this.GetInfo(1);
                    this.$helper.ShowMessage('success', 'عملية ناجحة', response.data.message || 'تم تنفيذ الإرجاع من القسم.');
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    const msg = err.response && err.response.data ? err.response.data : 'تعذر تنفيذ الإرجاع.';
                    this.$helper.ShowMessage('error', 'خطأ', msg);
                });
        },
        addIssueLine() {
            if (!this.issueForm.sourceStockingId) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'يرجى اختيار مخزن الصرف أولاً.');
                return;
            }
            this.issueForm.lines.push({ productsId: '', quantity: 1, unitMeasureId: '', note: '' });
        },
        removeIssueLine(index) {
            if (this.issueForm.lines.length <= 1) return;
            this.issueForm.lines.splice(index, 1);
        },
        submitDepartmentIssue() {
            const body = {
                facilityDepartmentId: Number(this.issueForm.facilityDepartmentId || 0),
                sourceStockingId: Number(this.issueForm.sourceStockingId || 0),
                note: this.issueForm.note || '',
                lines: (this.issueForm.lines || [])
                    .filter((x) => Number(x.productsId) > 0 && Number(x.quantity) > 0)
                    .map((x) => ({
                        productsId: Number(x.productsId),
                        quantity: Number(x.quantity),
                        unitMeasureId: Number(x.unitMeasureId || 0) > 0 ? Number(x.unitMeasureId) : null,
                        note: x.note || ''
                    }))
            };
            if (!body.facilityDepartmentId || !body.sourceStockingId || body.lines.length === 0) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'يرجى استكمال بيانات الصرف الداخلي.');
                return;
            }

            const missingUnit = (this.issueForm.lines || []).find((x) =>
                Number(x.productsId) > 0 && this.lineUnits(x).length > 0 && !Number(x.unitMeasureId || 0));
            if (missingUnit) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'يرجى اختيار وحدة الصرف لكل بند.');
                return;
            }

            const overAvailable = (this.issueForm.lines || []).find((x) =>
                Number(x.productsId) > 0 && this.lineExceedsAvailable(x, true));
            if (overAvailable) {
                const product = this.lineProduct(overAvailable);
                this.$helper.ShowMessage('warning', 'تنبيه',
                    'الكمية المطلوبة تتجاوز الرصيد المتاح للصنف ' + ((product && product.name) || '') + '.');
                return;
            }
            // أرصدة اللحظة لا أرصدة فتح النافذة: الدفعة المعروضة في المراجعة يجب أن
            // تكون هي الدفعة المخصومة، وإلا صارت النافذة طمأنينة كاذبة.
            this.$blockUI.Start();
            this.loadIssueProductsByStocking().then(() => {
                this.$blockUI.Stop();

                const missing = (this.issueForm.lines || []).find((x) =>
                    Number(x.productsId) > 0 && !this.lineProduct(x));
                if (missing) {
                    this.$helper.ShowMessage('warning', 'تغيّر الرصيد', 'أحد الأصناف لم يعد متاحاً في المخزن — راجع الأسطر.');
                    return;
                }

                const overNow = (this.issueForm.lines || []).find((x) =>
                    Number(x.productsId) > 0 && this.lineExceedsAvailable(x, true));
                if (overNow) {
                    const product = this.lineProduct(overNow);
                    this.$helper.ShowMessage('warning', 'تغيّر الرصيد',
                        'الكمية المطلوبة تتجاوز الرصيد المتاح الآن للصنف ' + ((product && product.name) || '') + '.');
                    return;
                }

                this.issueConfirmLines = (this.issueForm.lines || [])
                    .filter((x) => Number(x.productsId) > 0 && Number(x.quantity) > 0)
                    .map((line) => {
                        const product = this.lineProduct(line) || {};
                        const units = this.lineUnits(line);
                        const unit = units.find((u) => Number(u.unitMeasureId) === Number(line.unitMeasureId));
                        return {
                            name: product.name,
                            scientificName: product.scientificName,
                            nationalCode: product.nationalCode,
                            dosageForm: product.dosageForm,
                            manufacturerName: product.manufacturerName,
                            availableText: this.lineAvailableText(line, true),
                            requestedText: `${line.quantity} ${unit ? unit.unitName : ''}`.trim(),
                            baseQuantity: this.lineBaseQuantity(line),
                            baseUnitName: product.baseUnitName,
                            note: line.note,
                            batches: this.lineBatchPlan(line, true).filter((b) => b.take > 0)
                        };
                    });

                this.issueConfirmDialog = true;
            });
        },

        /** التنفيذ الفعلي — لا يُستدعى إلا من نافذة المراجعة. */
        confirmDepartmentIssue() {
            const body = {
                facilityDepartmentId: Number(this.issueForm.facilityDepartmentId || 0),
                sourceStockingId: Number(this.issueForm.sourceStockingId || 0),
                note: this.issueForm.note || '',
                lines: (this.issueForm.lines || [])
                    .filter((x) => Number(x.productsId) > 0 && Number(x.quantity) > 0)
                    .map((x) => ({
                        productsId: Number(x.productsId),
                        quantity: Number(x.quantity),
                        unitMeasureId: Number(x.unitMeasureId || 0) > 0 ? Number(x.unitMeasureId) : null,
                        note: x.note || ''
                    }))
            };

            this.issueConfirming = true;
            this.$blockUI.Start();
            this.$http.CreateDepartmentIssueVoucher(body)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.issueConfirming = false;
                    this.issueConfirmDialog = false;
                    this.createDialog = false;
                    this.GetInfo(1);
                    this.$helper.ShowMessage('success', 'عملية ناجحة', response.data.message || 'تم إنشاء سند الصرف الداخلي.');
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    this.issueConfirming = false;
                    this.issueConfirmDialog = false;
                    const msg = err.response && err.response.data ? err.response.data : 'تعذر تنفيذ الصرف الداخلي.';
                    this.$helper.ShowMessage('error', 'خطأ', msg);
                    // الرفض غالباً بسبب رصيد تغيّر — نُحدّث المعروض بدل إعادة المحاولة على رقم قديم.
                    this.loadIssueProductsByStocking();
                });
        },
        /** دفعة منتهية أو على وشك — تُميَّز في المراجعة ليراها المستخدم قبل الصرف. */
        batchExpiryClass(batch) {
            if (!batch || !batch.expiryDate) return '';
            const days = (new Date(batch.expiryDate) - new Date()) / 86400000;
            if (days < 0) return 'text-danger fw-semibold';
            if (days <= 90) return 'text-warning fw-semibold';
            return '';
        },

        batchExpiryNote(batch) {
            if (!batch || !batch.expiryDate) return 'بلا تاريخ صلاحية';
            const days = Math.floor((new Date(batch.expiryDate) - new Date()) / 86400000);
            if (days < 0) return 'منتهية الصلاحية';
            if (days <= 90) return `تنتهي خلال ${days} يوم`;
            return '';
        },

        issueDepartmentName() {
            const id = Number(this.issueForm.facilityDepartmentId || 0);
            const d = (this.departments || []).find((x) => Number(x.id) === id);
            return d ? d.name : '';
        },

        decisionBadgeClass(decision) {
            if (decision === 2) return 'bg-label-success';
            if (decision === 3) return 'bg-label-danger';
            return 'bg-label-warning';
        },
        printDetail() {
            if (!this.detail || !this.detail.id || !this.detail.canPrint) return;
            this.$http.MarkStockVoucherPrinted(this.detail.id)
                .then(() => {
                    const opened = printStockVoucher(this.detail, {
                        buildFor: 'وزارة الصحة',
                        logoUrl: mohLogo
                    });
                    if (!opened) {
                        this.$helper.ShowMessage('warning', 'تنبيه', 'تعذر فتح نافذة الطباعة. تحقق من مانع النوافذ.');
                        return;
                    }
                    this.$http.GetStockVoucher(this.detail.id).then((response) => {
                        this.detail = response.data.info;
                        this.GetInfo(this.pageNo);
                    });
                })
                .catch((err) => {
                    const msg = err.response && err.response.data ? err.response.data : 'تعذر تسجيل الطباعة.';
                    this.$helper.ShowMessage('error', 'خطأ', msg);
                });
        }
    }
};
